module.exports = __webpack_public_path__ + "static/yahoo_calendar_1-ec9c62ddee594acc3de07895fa5b318d.png";